import React, { useState } from 'react';
import { object, string, func} from 'prop-types';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { Overlay } from '_ui-core-js/React/components/Overlay.jsx';
import { Loader } from '../../partials';
import { publish } from '_ui-core-js/utilities/events.js';
import { deleteWebGlCongfiguration } from '../../store/actions/user';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function DeleteModal(props) {
    const {
        globalTheme, 
        atmosphere, 
        configId, 
        copy,
        confirmText, 
        cancelText, 
        onDeletion, 
        user, 
        errorText 
    } = props;

    const block = 'c-showroom-modal';
    const useDarkTheme = globalTheme === "light-theme"; // we want alternate to the atmosphere theme 
    const isBaseGrade = atmosphere === 'LBX';
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false)

    const showModal = (e) => {
        fireGTMTrackingEvent({
            name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
            componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceCollection,
            componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
            action: CORE_GTM_TRACKING_VALUES.action.deleteVersion,
            label: `${atmosphere.toLowerCase()}`
        });

        publish('trigger-open-overlay', { overlayId:`delete-webgl-config-modal-${configId}`}, window);

    };

    const closeModal = () => {
        publish('trigger-close-overlay-externally', {}, window);
    }

    const deleteItem = async () => {
        setIsLoading(true);
        try {
            fireGTMTrackingEvent({
                name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
                componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceCollection,
                componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
                action: CORE_GTM_TRACKING_VALUES.action.confirmDelete,
                label: `${atmosphere.toLowerCase()}`
            });

            await deleteWebGlCongfiguration({
                id: configId, 
                locale: user.locale, 
                token: user.token
            });
            closeModal();
            // update the state after closing the modal 
            const updatedWebglConfigs = user.webglConfigurations.filter(item => item.id !== configId);
            user.setWebglConfigurations(updatedWebglConfigs);
            onDeletion && await onDeletion(configId); //needed for animation retrigger
        } catch {
            setIsLoading(false);
            setIsError(true);
        }
    };

    return (
        <>
            <button className={`${block}__launch-button`} id={configId} onClick={showModal} aria-label='delete item'>
            </button>

            <Overlay 
            id={`delete-webgl-config-modal-${configId}`}
            showCloseButton={false}
            classes={'c-overlay--centered c-overlay--dialog'}
            theme={ useDarkTheme ? 'dark-theme' : 'light-theme-lighter'}>
                <article className={block}>
                    <section className={`${block}__contents`}>
                        <span className={`${block}__icon`} aria-hidden>
                            ?
                        </span>
                        <p className={`${block}__copy h5`}>
                            {copy}
                        </p>
                        <span className='h1'>
                            {!isBaseGrade && (
                                'LBX ' 
                                ) 
                            }
                            <span
                                className={`h1 apply-lbx-theme-text lbx-theme-${atmosphere.toLowerCase()}`}
                            >
                                {atmosphere}
                            </span>
                        </span>
                        <div>
                            {isLoading ?
                                <Loader theme={atmosphere.toLowerCase()} />
                                :
                                <>
                                    {isError ? 
                                        <p className={`${block}__error-copy h5`}>
                                            {errorText}
                                        </p>
                                    :
                                        <Button
                                        label={confirmText}
                                        type='primary'
                                        onClickCallback={deleteItem}
                                        gtmComponentGroup={CORE_GTM_TRACKING_VALUES.componentGroup.newCars}
                                        gtmComponentName={LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceCollection}
                                        gtmAction={CORE_GTM_TRACKING_VALUES.action.deleteVersion}
                                        gtmLabel={atmosphere} 
                                        />
                                    }
                                    <Button 
                                    label={cancelText} 
                                    type='secondary'
                                    onClickCallback={closeModal} 
                                    />
                                </>
                            }
                        </div>
                    </section>
                </article>
            </Overlay>            
        </>
    );
}

DeleteModal.propTypes = {
    globalTheme:string, 
    atmosphere:string, 
    configId:string, 
    copy:string,
    confirmText:string, 
    cancelText:string, 
    onDeletion:func, 
    user:object, 
    errorText: string,  
  };